import styled                     from 'styled-components';

import { InputTextboxVariants   } from 'src/components/common/input/input-textbox';
import { ButtonVariants         } from 'src/components/common/button';
import { InputCalendarVariants  } from 'src/components/common/input/input-calendar';
import { LabeledContentVariants } from 'src/components/common/labeled-content';
import { TagsVariants           } from 'src/components/common/tags';
import { SwitchVariants         } from 'src/components/common/switch';

import { ReferSelectorVariants  } from 'src/components/features/common/refer-selector';

import { themeColors,
         Typo,
         typoAsCSS,
         themeTypos,
         cssFlexRow,
         cssFlexColumn          } from 'src/providers/theme/shared';



export type FilterLookAndFeel = {
  headerHeight: number;
  headerTextColor: string;
  headerBackgroundColor: string;
  headerTextTypo: Typo;
  headerButtonVariant: ButtonVariants;

  formContainerPaddings: number[];
  formContainerBackgroundColor: string;
  formContainerGap: number;

  actionGap: number;
  actionCancelVariant: ButtonVariants;
  actionAcceptVariant: ButtonVariants;

  dateGap: number;
  dateInputVariant: InputCalendarVariants;

  labeledVariant: LabeledContentVariants;
  inputVariant: InputTextboxVariants;

  referSelectorVariant: ReferSelectorVariants;

  tagsVariant: TagsVariants;
  switchVariant: SwitchVariants;
}

const filter_light: FilterLookAndFeel = {
  headerHeight: 60,
  headerTextColor: themeColors.PrimaryBlack,
  headerBackgroundColor: themeColors.PrimaryWhite,
  headerTextTypo: themeTypos.GRTSKREG_W500_S16_LH24,
  headerButtonVariant: 'textBig',

  formContainerPaddings: [20],
  formContainerBackgroundColor: themeColors.SurfaceBackgroundPrimary,
  formContainerGap: 10,

  actionGap: 16,
  actionCancelVariant: 'textBig',
  actionAcceptVariant: 'primaryBig',

  dateGap: 16,
  dateInputVariant: 'h48capsule',

  labeledVariant: 'blackw400s12lh16gap8',
  inputVariant: 'h48capsule',

  referSelectorVariant: 'light',
  tagsVariant: 'chipsWrap',
  switchVariant: 'w42h26',
}

export type FilterVariants = 'light';

export const filter_variants: Map<FilterVariants, FilterLookAndFeel> = 
  new Map<FilterVariants, FilterLookAndFeel>([
    ['light', filter_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexColumn};
  width: 100%;
  height: 100dvh;
`

export const HeaderContainer = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexRow};
  flex-shrink: 0;
  width: 100%;
  align-items: center;
  padding: 0px 20px;
  border-bottom: 1px solid ${themeColors.BorderPrimary};

  background-color: ${(args) => args.lookAndFeel.headerBackgroundColor};

  & > *:first-child {
    flex-grow: 2;
    text-align: center;
  }
`

export const HeaderLabel = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexRow};
  flex-grow: 2;
  justify-content: left;

  color: ${(args) => args.lookAndFeel.headerTextColor};
  ${(args) => typoAsCSS(args.lookAndFeel.headerTextTypo)}
`

export const FormContainer = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexColumn};
  width: 100%;
  flex-grow: 2;
  gap: ${(args) => args.lookAndFeel.formContainerGap}px;
  overflow-y: scroll;

  background-color: ${(args) => args.lookAndFeel.formContainerBackgroundColor};
  padding: ${(args) => args.lookAndFeel.formContainerPaddings[0]}px;

  & > * {
    flex-shrink: 0;
  }
`

export const ActionsContainer = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexRow};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.actionGap}px;
  justify-content: space-between;

  background-color: ${(args) => args.lookAndFeel.formContainerBackgroundColor};
  padding: ${(args) => args.lookAndFeel.formContainerPaddings[0]}px;

  & > * {
    flex-grow: 1;
  }
`

export const DateContainer = styled.div<{
  lookAndFeel: FilterLookAndFeel,
}>`
  ${cssFlexRow};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.dateGap}px;

  & > * {
    flex-grow: 1;
    flex-shrink: 0;
  }
`
